export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[960px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14 p-8 md:p-12 rounded-2xl bg-background-100 border border-background-200/60">
            <div className="flex-shrink-0 w-40 h-40 md:w-48 md:h-48 rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20mobile%20phone%20mockup%20with%20cinema%20app%20interface%2C%20warm%20red%20and%20gold%20color%20scheme%2C%20elegant%20minimalist%20design%2C%20movie%20poster%20grid%20layout%2C%20clean%20UI%20with%20soft%20shadows&width=480&height=480&seq=app-mockup-01&orientation=squarish"
                alt="丫丫影院移动端入口"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>

            <div className="flex-1 text-center lg:text-left">
              <span className="inline-block px-3 py-1 bg-primary-100/70 text-primary-700 text-xs font-medium rounded-full mb-3">
                随时随地观影
              </span>
              <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-3">
                手机访问更便捷
              </h2>
              <p className="text-sm text-foreground-500 leading-relaxed mb-6 max-w-[480px]">
                丫丫影院已全面适配移动端，无需下载APP，手机浏览器打开即可享受最新电影不缓冲、最新电视剧流畅的观影体验。躺在床上、通勤路上，随时随地在线观看最新影视，高清免费不卡顿。
              </p>
              <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
                <a
                  href="#hero"
                  className="px-6 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-lg hover:bg-primary-600 transition-colors inline-flex items-center gap-2 whitespace-nowrap"
                >
                  <i className="ri-smartphone-line"></i>
                  手机端访问
                </a>
                <a
                  href="#features"
                  className="px-6 py-2.5 border border-foreground-300 text-foreground-700 text-sm font-medium rounded-lg hover:bg-background-50 transition-colors whitespace-nowrap"
                >
                  了解功能特色
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}